import { MileageRequestComputationContentSchemeExplanation } from 'modules/requests/mileage/shared/MileageRequestComputationContentSchemeExplanation';
import { PanelItemsSection } from 'src/core/common/components/Panel';
import { ErrorBoundary } from 'src/core/common/components/withErrorBoundary';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { LocationsCard } from 'src/core/modules/requests/components/common/LocationsCard';

import { getMileageItems } from '../../../prepare-payables/components/PreparePayablesInbox/components/PreparePayablesEditorForm/helpers';
import type { Payable } from '../../containers/PayablePanelContainer';
import { type PayableType } from '../../models/payable';

type Props = {
  payable: Payable;
};

export const MileageSection = ({ payable }: Props) => {
  const { t, localeFormat } = useTranslation('global');

  const isMileagePayable = getIsMileagePayable(payable.type);

  if (!isMileagePayable || !payable.mileageDetails) {
    return <></>;
  }

  return (
    <>
      <div>
        <ErrorBoundary
          context={{
            team: 'travel-and-expenses',
            scope: 'payable::panel::mileage',
          }}
        >
          <LocationsCard
            locationsDescriptions={payable.mileageDetails.locationsAddresses}
            journeyPath={JSON.stringify(payable.mileageDetails.journey)}
          />
        </ErrorBoundary>
      </div>

      <PanelItemsSection
        title={t('payables.panel.mileage.title')}
        items={[
          ...getMileageItems({
            vehicle: payable.mileageDetails?.vehicle,
            scheme: payable.mileageDetails?.scheme,
            travelDate: payable.mileageDetails?.travelDate,
            totalDistanceOverYear:
              payable.mileageDetails?.vehicle?.totalDistanceOverYear,
            passengers: payable.mileageDetails?.passengers,
            t,
            localeFormat,
          }),
        ]}
        footer={
          <MileageRequestComputationContentSchemeExplanation
            className="mt-16"
            schemeType={reshapePayableMileageSchemeType(
              payable.mileageDetails?.scheme.type,
            )}
          />
        }
      />
    </>
  );
};

export const reshapePayableMileageSchemeType = (
  schemeType: 'french' | 'german' | 'uk' | 'custom' | undefined,
) => {
  switch (schemeType) {
    case 'french':
      return 'FR';
    case 'german':
      return 'DE';
    case 'uk':
      return 'UK';
    case 'custom':
      return 'FX';
    default:
      return undefined;
  }
};

const getIsMileagePayable = (type: PayableType) => {
  return type === 'mileageAllowance';
};
